'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.hasOffersInRootCategory = hasOffersInRootCategory;
exports.getCatalog = getCatalog;
exports.getCategories = getCategories;
exports.getProducts = getProducts;
exports.getProduct = getProduct;
exports.getProductByCategory = getProductByCategory;
exports.getByCategory = getByCategory;
exports.searchProducts = searchProducts;
exports.resetSearchProducts = resetSearchProducts;
exports.setSearchClose = setSearchClose;
exports.getCategoryRecommended = getCategoryRecommended;
exports.checkCatalogForUpdates = checkCatalogForUpdates;
exports.refreshCatalog = refreshCatalog;

var _constants = require('redux/constants');

var _setting = require('redux/actions/setting');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasOffersInRootCategory() {
    return {
        types: [_constants.CatalogConstants.LOAD_HAS_OFFERS_IN_ROOT, _constants.CatalogConstants.LOAD_HAS_OFFERS_IN_ROOT_SUCCESS, _constants.CatalogConstants.LOAD_HAS_OFFERS_IN_ROOT_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getCatalog().then(function (response) {
                // получим id рутовой категории
                var rootCategoryId = (0, _keys2.default)(response)[0];
                // получим товары рутовой категории
                return iBonus.getByCategory(rootCategoryId, 0, _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT).then(function (products) {
                    return products.count > 0;
                });
            });
        }
    };
}

function getCatalog() {
    return {
        types: [_constants.CatalogConstants.LOAD_CATALOG, _constants.CatalogConstants.LOAD_CATALOG_SUCCESS, _constants.CatalogConstants.LOAD_CATALOG_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getCatalog();
        }
    };
}

function getCategories() {
    return {
        types: [_constants.CatalogConstants.LOAD_CATEGORIES, _constants.CatalogConstants.LOAD_CATEGORIES_SUCCESS, _constants.CatalogConstants.LOAD_CATEGORIES_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getCategories();
        }
    };
}

function getProducts() {
    var searchName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var activePage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT;

    return {
        types: [_constants.CatalogConstants.LOAD, _constants.CatalogConstants.LOAD_SUCCESS, _constants.CatalogConstants.LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getProducts(searchName, activePage, limit).then(function (result) {
                return (0, _extends3.default)({}, result, {
                    searchName: searchName,
                    activePage: ++activePage,
                    limit: limit
                });
            });
        }
    };
}

function getProduct(id) {
    return {
        types: [_constants.CatalogConstants.LOAD_DETAIL, _constants.CatalogConstants.LOAD_DETAIL_SUCCESS, _constants.CatalogConstants.LOAD_DETAIL_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getProductById(id);
        }
    };
}

function getProductByCategory(_ref) {
    var id = _ref.id,
        _ref$page = _ref.page,
        page = _ref$page === undefined ? 0 : _ref$page,
        _ref$limit = _ref.limit,
        limit = _ref$limit === undefined ? _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT : _ref$limit;

    return {
        types: [_constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES, _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES_SUCCESS, _constants.CatalogConstants.LOAD_PRODUCT_BY_CATEGORIES_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getProductByCategory(id, page, limit).then(function (result) {
                if (result.offers.length === 0) {
                    return iBonus.getProductByCategory(id, 0, limit).then(function (result) {
                        return (0, _extends3.default)({}, result, {
                            activePage: 1,
                            limit: limit
                        });
                    });
                }
                return (0, _extends3.default)({}, result, {
                    activePage: ++page,
                    limit: limit
                });
            });
        }
    };
}

function getByCategory(_ref2) {
    var id = _ref2.id,
        _ref2$page = _ref2.page,
        page = _ref2$page === undefined ? 0 : _ref2$page,
        _ref2$limit = _ref2.limit,
        limit = _ref2$limit === undefined ? _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT : _ref2$limit;

    return {
        types: [_constants.CatalogConstants.LOAD_BY_CATEGORIES, _constants.CatalogConstants.LOAD_BY_CATEGORIES_SUCCESS, _constants.CatalogConstants.LOAD_BY_CATEGORIES_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getByCategory(id, page, limit).then(function (result) {
                if (result.offers.length === 0) {
                    return iBonus.getByCategory(id, 0, limit).then(function (result) {
                        return (0, _extends3.default)({}, result, {
                            activePage: 1,
                            limit: limit
                        });
                    });
                }
                return (0, _extends3.default)({}, result, {
                    activePage: ++page,
                    limit: limit
                });
            });
        }
    };
}

function searchProducts() {
    var searchName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.CatalogNumericConstants.SEARCH_PAGE_LIMIT;

    return {
        types: [_constants.CatalogConstants.SEARCH_PRODUCTS_LOAD, _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD_SUCCESS, _constants.CatalogConstants.SEARCH_PRODUCTS_LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getProducts(searchName, 0, limit).then(function (result) {
                return result.offers || [];
            });
        }
    };
}

function resetSearchProducts() {
    return {
        type: _constants.CatalogConstants.SEARCH_PRODUCTS_RESET
    };
}

function setSearchClose(close) {
    return {
        type: _constants.CatalogConstants.SET_SEARCH_CLOSE,
        payload: {
            close: close
        }
    };
}

function getCategoryRecommended(id) {
    return {
        types: [_constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD, _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD_SUCCESS, _constants.CatalogConstants.CATEGORY_RECOMENDED_LOAD_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getCategoryRecommended(id).then(function (result) {
                return (0, _extends3.default)({}, result, {
                    id: id
                });
            });
        }
    };
}

function checkCatalogForUpdates() {
    return {
        types: [_constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE, _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_SUCCESS, _constants.CatalogConstants.LOAD_LAST_CATALOG_UPDATE_DATE_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getChannelActualCatalogLabel();
        }
    };
}

function refreshCatalog() {
    return {
        types: [_constants.CatalogConstants.REFRESH_CATALOG_LOAD, _constants.CatalogConstants.REFRESH_CATALOG_LOAD_SUCCESS, _constants.CatalogConstants.REFRESH_CATALOG_LOAD_FAIL],
        promise: function promise(client, iBonus, _ref3) {
            var getState = _ref3.getState,
                dispatch = _ref3.dispatch;

            return dispatch(checkCatalogForUpdates()).then(function () {
                if (getState().catalog.hasUpdates) {
                    // return dispatch(getCategories())
                    //         .then(dispatch(loadSettings())
                    //             .then((result) => {
                    //                 const id = result.rootCategory.id,
                    //                       limit = CatalogNumericConstants.CATEGORY_PAGE_LIMIT;
                    //                 dispatch(getByCategory({id, limit, page: 1}));
                    //             }));
                } else {
                    return _promise2.default.resolve();
                }
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/catalog.js
// module id = 67
// module chunks = 0